import { useCopy } from '../hooks/useCopy'
import styles from './CopyEndpoint.module.css'

interface CopyEndpointProps {
    /** The url to place on the clipboard. */
    url: string
    /** What it belongs to, so the accessible name says which row this is. */
    name: string
}

/**
 * Copies a resolver endpoint from inside a dense row.
 *
 * The full CopyButton is a proper button with a text label -- right for a
 * toolbar, too heavy repeated down a chart. This keeps the same behaviour and
 * the same live-region announcement, in the footprint of the ✕ beside it.
 */
export default function CopyEndpoint({ url, name }: CopyEndpointProps) {
    const { copied, copy } = useCopy()

    return (
        <>
            <button
                type="button"
                className={copied ? styles.copied : styles.copy}
                onClick={() => copy(url)}
                title={url}
                aria-label={`Copy the endpoint for ${name}: ${url}`}
            >
                {copied ? 'copied' : 'copy url'}
            </button>
            <span role="status" aria-live="polite" className="visually-hidden">
                {copied ? `Copied: ${url}` : ''}
            </span>
        </>
    )
}
